module.exports = __webpack_public_path__ + "img/manage_accounts_black_24dp.ce2fbe6e.svg";